import React from 'react';
import { Link } from 'react-router-dom';

/* ── Module data ── */
const modules = [
  {
    icon: (
      <svg className="w-8 h-8" fill="none" stroke="currentColor" strokeWidth={1.5} viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 14.25v-2.625a3.375 3.375 0 00-3.375-3.375h-1.5A1.125 1.125 0 0113.5 7.125v-1.5a3.375 3.375 0 00-3.375-3.375H8.25m0 12.75h7.5m-7.5 3H12M10.5 2.25H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 00-9-9z" />
      </svg>
    ),
    title: 'Policy Updates',
    desc: 'Real-time regulatory and legislative tracking across jurisdictions. Know how policy shifts affect your portfolio before markets react.',
  },
  {
    icon: (
      <svg className="w-8 h-8" fill="none" stroke="currentColor" strokeWidth={1.5} viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" d="M3 13.125C3 12.504 3.504 12 4.125 12h2.25c.621 0 1.125.504 1.125 1.125v6.75C7.5 20.496 6.996 21 6.375 21h-2.25A1.125 1.125 0 013 19.875v-6.75zM9.75 8.625c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125v11.25c0 .621-.504 1.125-1.125 1.125h-2.25a1.125 1.125 0 01-1.125-1.125V8.625zM16.5 4.125c0-.621.504-1.125 1.125-1.125h2.25C20.496 3 21 3.504 21 4.125v15.75c0 .621-.504 1.125-1.125 1.125h-2.25a1.125 1.125 0 01-1.125-1.125V4.125z" />
      </svg>
    ),
    title: 'Financial Metrics',
    desc: 'Custom metric builders with deep financial data. Compare performance across sectors, geographies, and asset classes.',
  },
  {
    icon: (
      <svg className="w-8 h-8" fill="none" stroke="currentColor" strokeWidth={1.5} viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" d="M12 9v3.75m0-10.036A11.959 11.959 0 013.598 6 11.99 11.99 0 003 9.75c0 5.592 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.31-.21-2.57-.598-3.75h-.152c-3.196 0-6.1-1.249-8.25-3.286zm0 13.036h.008v.008H12v-.008z" />
      </svg>
    ),
    title: 'Credit Risk',
    desc: 'Issuer-level credit scoring and stress-testing tools. Monitor exposure against macro scenarios.',
  },
  {
    icon: (
      <svg className="w-8 h-8" fill="none" stroke="currentColor" strokeWidth={1.5} viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" d="M9 12.75L11.25 15 15 9.75m-3-7.036A11.959 11.959 0 013.598 6 11.99 11.99 0 003 9.749c0 5.592 3.824 10.29 9 11.623 5.176-1.332 9-6.03 9-11.622 0-1.31-.21-2.571-.598-3.751h-.152c-3.196 0-6.1-1.248-8.25-3.285z" />
      </svg>
    ),
    title: 'ESG Compliance',
    desc: 'ESG scoring aligned with global reporting frameworks. Stay compliant as standards evolve.',
  },
  {
    icon: (
      <svg className="w-8 h-8" fill="none" stroke="currentColor" strokeWidth={1.5} viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" d="M2.25 18L9 11.25l4.306 4.307a11.95 11.95 0 015.814-5.519l2.74-1.22m0 0l-5.94-2.28m5.94 2.28l-2.28 5.941" />
      </svg>
    ),
    title: 'Investment Trends',
    desc: 'AI-assisted trend analysis. Surface emerging themes before consensus forms.',
  },
  {
    icon: (
      <svg className="w-8 h-8" fill="none" stroke="currentColor" strokeWidth={1.5} viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" d="M3.75 6A2.25 2.25 0 016 3.75h2.25A2.25 2.25 0 0110.5 6v2.25a2.25 2.25 0 01-2.25 2.25H6a2.25 2.25 0 01-2.25-2.25V6zM3.75 15.75A2.25 2.25 0 016 13.5h2.25a2.25 2.25 0 012.25 2.25V18a2.25 2.25 0 01-2.25 2.25H6A2.25 2.25 0 013.75 18v-2.25zM13.5 6a2.25 2.25 0 012.25-2.25H18A2.25 2.25 0 0120.25 6v2.25A2.25 2.25 0 0118 10.5h-2.25a2.25 2.25 0 01-2.25-2.25V6zM13.5 15.75a2.25 2.25 0 012.25-2.25H18a2.25 2.25 0 012.25 2.25V18A2.25 2.25 0 0118 20.25h-2.25A2.25 2.25 0 0113.5 18v-2.25z" />
      </svg>
    ),
    title: 'Integrated Dashboard',
    desc: 'All modules in one unified workspace. Data flows across views so your team works faster.',
  },
];

/* ── Why GIRMP pillars ── */
const pillars = [
  {
    title: 'Private by Design',
    desc: 'Every deployment is isolated. Your data, your environment, your analysis — never shared, never aggregated.',
  },
  {
    title: 'Mandate-Configured',
    desc: 'Your GIRMP instance is configured around your investment mandate and coverage universe during onboarding.',
  },
  {
    title: 'Live Data Coverage',
    desc: 'Continuous ingestion from regulatory bodies, financial data providers, and ESG frameworks. Always current.',
  },
];

const GIRMP: React.FC = () => {
  return (
    <div className="pt-16 min-h-screen bg-[#060d18]">

      {/* ── Hero ── */}
      <section className="relative py-28 overflow-hidden">
        {/* Subtle gradient glow */}
        <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-[600px] h-[400px] bg-[#3E92CC]/15 rounded-full blur-[120px] pointer-events-none" />

        <div className="relative max-w-3xl mx-auto px-6 text-center">
          <Link
            to="/products"
            className="inline-flex items-center text-sm text-[#3E92CC]/70 hover:text-[#3E92CC] transition-colors mb-8"
          >
            <svg className="w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
            </svg>
            All Products
          </Link>
          <h1 className="text-5xl md:text-6xl font-serif text-white mb-4 tracking-tight">
            GIRMP
          </h1>
          <p className="text-lg text-white/50 mb-6">
            Green Infrastructure Risk Management Platform
          </p>
          <p className="text-xl text-white/80 leading-relaxed max-w-2xl mx-auto">
            Six intelligence modules. One unified view. Each module is purpose-built for 
            institutional workflows and can be configured to match your mandate.
          </p>
        </div>
      </section>

      {/* ── The Platform — 6 modules ── */}
      <section className="py-20">
        <div className="max-w-6xl mx-auto px-6">
          <p className="text-sm font-semibold tracking-widest text-[#3E92CC] uppercase mb-3 text-center">
            The Platform
          </p>
          <h2 className="text-3xl md:text-4xl font-serif text-white mb-4 text-center">
            Six intelligence modules. One unified view.
          </h2>
          <p className="text-white/50 text-center max-w-2xl mx-auto mb-16">
            Each module is purpose-built for institutional workflows and can be configured to match your mandate.
          </p>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {modules.map((mod) => (
              <div
                key={mod.title}
                className="relative bg-white/[0.03] backdrop-blur-sm border border-white/[0.08] rounded-xl p-7 hover:border-[#3E92CC]/30 hover:bg-white/[0.05] transition-all duration-300 group"
              >
                <div className="text-[#3E92CC] mb-4 opacity-80 group-hover:opacity-100 transition-opacity">
                  {mod.icon}
                </div>
                <h3 className="text-lg font-bold text-white mb-2">{mod.title}</h3>
                <p className="text-white/50 text-sm leading-relaxed">{mod.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── Why GIRMP ── */}
      <section className="relative py-24 overflow-hidden">
        {/* Glow */}
        <div className="absolute bottom-1/3 left-1/2 -translate-x-1/2 w-[500px] h-[500px] bg-[#3E92CC]/10 rounded-full blur-[140px] pointer-events-none" />

        <div className="relative max-w-5xl mx-auto px-6">
          <p className="text-sm font-semibold tracking-widest text-[#3E92CC] uppercase mb-3 text-center">
            Why GIRMP
          </p>
          <h2 className="text-3xl md:text-4xl font-serif text-white mb-16 text-center">
            Built different. On purpose.
          </h2>

          <div className="grid md:grid-cols-3 gap-12">
            {pillars.map((p) => (
              <div key={p.title} className="text-center">
                <h3 className="text-lg font-bold text-white mb-3">{p.title}</h3>
                <p className="text-white/50 text-sm leading-relaxed">{p.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── CTA ── */}
      <section className="py-20 border-t border-white/[0.06]">
        <div className="max-w-3xl mx-auto px-6 text-center">
          <h2 className="text-2xl font-serif text-white mb-4">
            See it in action
          </h2>
          <p className="text-white/50 mb-8">
            Schedule a walkthrough configured to your mandate and coverage universe.
          </p>
          <Link
            to="/contact"
            className="inline-block px-8 py-3 bg-[#3E92CC] text-white rounded-lg hover:bg-[#3E92CC]/90 transition-colors font-medium"
          >
            Schedule Demo
          </Link>
        </div>
      </section>
    </div>
  );
};

export default GIRMP;
